import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Archive, Home, Error } from "./pages";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";
import TalkBusiness from "./components/TalkBusiness/Projects";
import SupportProject from "./components/Support/Support";
import SupportSystem from "./components/SupportSystem/Supports";
AOS.init({
  once: true,
  disable: () => window.innerWidth > 700,
});


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/talkBusiness" element={<TalkBusiness />} />
        <Route path="/archive" exact element={<Archive />} />
        <Route path="/support" exact element={<SupportSystem />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
